<template>
<mdb-navbar id="top" color="white" dark animated animation="3" navIconClass="dark-blue-text" position="top" class="justify-content-end">
    <mdb-navbar-brand class="" href="https://mdbootstrap.com/">
        <img src="../assets/logo.png" height="60" alt="">
    </mdb-navbar-brand>
    <mdb-navbar-toggler class=" ml-0 order-lg-1 ">
        <mdb-navbar-nav center class="smooth-scroll" v-mdb-scroll-spy>
            <mdb-nav-item href="#top" @click.native.prevent="home" active>Inicio</mdb-nav-item>
            <mdb-nav-item href="#info" @click.native.prevent="info">Info</mdb-nav-item>
            <mdb-nav-item href="#services" @click.native.prevent="services">Servicios</mdb-nav-item>
            <mdb-nav-item href="#work" @click.native.prevent="work">Trabajos</mdb-nav-item>
            <mdb-nav-item href="#contact" @click.native.prevent="contact">Contacto</mdb-nav-item>
        </mdb-navbar-nav>
    </mdb-navbar-toggler>
    <div class=" ml-auto order-lg-2">
        <a v-if="!$store.state.loggedIn" @click="toggleLogin(true)">
            <mdb-icon class="menu" fas icon="user-plus" size="2x" />
        </a>
        <mdb-dropdown>
            <mdb-dropdown-toggle class="pl-1 pt-1 pr-1" ref="toggle" slot="toggle">
                <a v-if="$store.state.loggedIn">
                    <mdb-icon  class="menu" fas icon="user" size="2x" />
                </a>
            </mdb-dropdown-toggle>
            <mdb-dropdown-menu color="info" class="mt-2">
                <mdb-dropdown-item>Profile</mdb-dropdown-item>
                <div class="dropdown-divider"></div>
                <mdb-dropdown-item @click="logOut">
                    <mdb-icon icon="sign-out-alt" /> Salir</mdb-dropdown-item>
            </mdb-dropdown-menu>
        </mdb-dropdown>

        <!-- <mdb-btn  @click.native="toggleEstimate(true)" outline="info" size="sm" darkWaves rounded class="mt-0">Estimado</mdb-btn> -->

        <!-- <a class="ml-2">
            <mdb-icon fas icon="shopping-cart" size="2x" /> 
        </a> -->
        
    </div>
</mdb-navbar>
</template>

<script>
import {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    // mdbBtn,
    mdbSmooth,
    mdbScrollSpy,
    mdbIcon,
    mdbDropdown,
    mdbDropdownMenu,
    mdbDropdownToggle,
    mdbDropdownItem,
} from 'mdbvue';
import store from '../store/index'
import firebase from 'firebase'
export default {
    name: 'NavbarPage',
    components: {
        mdbNavbar,
        mdbNavbarBrand,
        mdbNavbarToggler,
        mdbNavbarNav,
        mdbNavItem,
        mdbIcon,
        // mdbBtn,
        mdbDropdown,
        mdbDropdownMenu,
        mdbDropdownToggle,
        mdbDropdownItem,
    },
    directives: {
        mdbSmooth,
        mdbScrollSpy
    },
    methods: {
        home() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },
        info() {
            window.scroll({
                top: 930,
                left: 0,
                behavior: 'smooth'
            });
        },
        services() {
            window.scroll({
                top: 1330,
                left: 0,
                behavior: 'smooth'
            });
        },
        work() {
            window.scroll({
                top: 1950,
                left: 0,
                behavior: 'smooth'
            });
        },
        contact() {
            window.scroll({
                top: 1950,
                left: 0,
                behavior: 'smooth'
            });
        },
        toggleLogin(b) {
            store.commit('toggleLogin', b)
        },
        toggleEstimate(b){
            if (store.state.loggedIn === false) {
                this.$notify.info({
                    message: 'Debe estar registrado para el estimado',
                    position: 'top right',
                    timeOut: 3000
                });
            }
            else{
                 store.commit('toggleEstimate', b)
            }
           
        },
        logOut() {
            firebase.auth().signOut().then(() => {
                this.$notify.info({
                    message: 'You have successfully signed out!',
                    position: 'bottom full width',
                    timeOut: 3000
                });
            })
        },
         estimate() {
            if (store.state.loggedIn === false) {
                this.$notify.info({
                    message: 'Debe estar registrado para el estimado',
                    position: 'top right',
                    timeOut: 3000
                });
            }
            else{
                this.$router.push('/about')
            }
        }
    }
}
</script>

<style lang="css">
.nav-link {
    font-size: 20px !important;
    color: grey !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
}

.active {
    color: black !important;
}

.animated-icon3 span[data-v-5e1632bb] {
    background-color: black !important;
}

.menu.fas.fa-user-plus,
.menu.fas.fa-user,
.fas.fa-shopping-cart {
    color: transparent;
    -webkit-text-stroke-width: 1.9px;
    -webkit-text-stroke-color: rgb(51, 181, 229);
    /* padding-right: 10px; */
    font-size: 1.5rem;
}

.dropdown-toggle:after {
    display: none;
    box-shadow: none !important;
    /* padding: 0px !important; */
}

.dropdown-toggle {
    box-shadow: none !important;
}

/* Extra small devices (portrait phones, less than 576px) */
/* No media query since this is the default in Bootstrap */

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
    #socialNav {
        flex: none !important;
        text-align: center !important;
        /* justify-content: none !important; */
    }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
    .navbar-nav {
        margin-left: 0px !important;
    }
}
</style>
